module.exports = __webpack_public_path__ + "static/media/coffeebar_thumb.9f4b958d.webp";